export default __webpack_public_path__ + "static/media/img-ln-7-owl-people-big.4ff27ba7.png";